import { Outlet } from 'react-router-dom';
import { UniverseTabs, type UniverseTab } from '../../components/templates/UniverseTabs';
import styles from '../../components/templates/UniverseLayout.module.css';

/* Analyses available under the Platforms universe. Add tabs here as they ship. */
const PLATFORMS_TABS: UniverseTab[] = [
  { id: 'leaderboard', label: 'Leaderboard' },
  { id: 'catalog', label: 'Catalog' },
];

export function PlatformsLayout() {
  return (
    <div className={styles.base}>
      <h1 className={styles.title}>Platforms</h1>
      <UniverseTabs baseRoute="/platforms" tabs={PLATFORMS_TABS} />
      <Outlet />
    </div>
  );
}
